/** Gleiche Rücklagen-Rechnung wie im Kalkulator, für eine Leistung oder ein Paket. */

export interface RuecklageFaktoren {
    mwstSatz: number;
    gemeinkostenfaktor: number;
    unternehmerlohnAnteil: number;
    verlustAnteil: number;
    teamStundenlohn: number;
    lohnfortzahlungPercent: number;
    sozialPercent: number;
}

export interface RuecklageErgebnis {
    gewinn: number;
    gewinnPercent: number;
}

export function berechneRuecklage(
    faktoren: RuecklageFaktoren,
    opts: { brutto: number; minuten: number; materialNetto: number; geraeteNetto: number }
): RuecklageErgebnis {
    const mwst = (Number(faktoren.mwstSatz) || 0) / 100;
    const brutto = Number(opts.brutto) || 0;
    const netto = brutto / (1 + (mwst > -0.99 ? mwst : 0));
    const gk = Number(faktoren.gemeinkostenfaktor) || 0;
    const ul = Number(faktoren.unternehmerlohnAnteil) || 0;
    const vl = Number(faktoren.verlustAnteil) || 0;
    const mat = Number(opts.materialNetto) || 0;
    const dev = Number(opts.geraeteNetto) || 0;
    const minuten = Number(opts.minuten) || 0;
    const lohnBasis = (Number(faktoren.teamStundenlohn) || 0) * (minuten / 60);
    const urlaub = lohnBasis * ((Number(faktoren.lohnfortzahlungPercent) || 0) / 100);
    const sozial = (lohnBasis + urlaub) * ((Number(faktoren.sozialPercent) || 0) / 100);
    const uebrig = netto - mat - dev - netto * gk - netto * ul - netto * vl;
    const gewinn = Math.round((uebrig - lohnBasis - urlaub - sozial) * 100) / 100;
    const gewinnPercent = netto > 0 ? Math.round((gewinn / netto) * 1000) / 10 : 0;
    return { gewinn, gewinnPercent };
}
